import { render } from "./BFormValidFeedback.vue?vue&type=template&id=f0d06e04&ts=true"
import script from "./BFormValidFeedback.vue?vue&type=script&lang=ts"
export * from "./BFormValidFeedback.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__